"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewerResponsiveWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_d3_utils_1 = require("react-d3-utils");
const BrushXY_1 = __importStar(require("../1d-2d/tools/BrushXY"));
const CrossLinePointer_1 = __importDefault(require("../1d-2d/tools/CrossLinePointer"));
const BrushTracker_1 = require("../EventsTrackers/BrushTracker");
const MouseTracker_1 = require("../EventsTrackers/MouseTracker");
const ChartContext_1 = require("../context/ChartContext");
const DispatchContext_1 = require("../context/DispatchContext");
const Spinner_1 = __importDefault(require("../loader/Spinner"));
const ToolTypes_1 = require("../toolbar/ToolTypes");
const Chart2D_1 = __importDefault(require("./Chart2D"));
const FooterBanner_1 = __importDefault(require("./FooterBanner"));
const SlicingView_1 = __importDefault(require("./SlicingView"));
const XYLabelPointer_1 = __importDefault(require("./tools/XYLabelPointer"));
const DimensionLayout_1 = require("./utilities/DimensionLayout");
const scale_1 = require("./utilities/scale");
function Viewer2D({ emptyText = undefined }) {
    const state = (0, ChartContext_1.useChartData)();
    const { toolOptions: { selectedTool }, isLoading, data, margin, view: { spectra: { activeSpectra, activeTab }, }, } = state;
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const brushStartRef = (0, react_1.useRef)(null);
    const spectrumData = (0, react_1.useMemo)(() => {
        const nuclei = activeTab.split(',');
        return nuclei.map((nucleus) => {
            const spectra = activeSpectra[nucleus];
            if (spectra?.length === 1) {
                const id = spectra[0].id;
                const spectrum = data.find((datum) => datum.id === id && !datum.info.isFid);
                return spectrum;
            }
            return null;
        });
    }, [activeTab, data, activeSpectra]);
    const DIMENSION = (0, DimensionLayout_1.get2DDimensionLayout)(state);
    function handelBrush(brushData) {
        const { startX: startXInPixel, endX: endXInPixel, startY: startYInPixel, endY: endYInPixel, mouseButton, } = brushData;
        if (mouseButton === 'secondary') {
            const scaleX = (0, scale_1.get2DXScale)(state);
            const scaleY = (0, scale_1.get2DYScale)(state);
            if (!brushStartRef.current) {
                const x = scaleX.invert(startXInPixel);
                const y = scaleY.invert(startYInPixel);
                brushStartRef.current = { x, y };
            }
            const { x, y } = brushStartRef.current;
            const shiftX = scaleX.invert(endXInPixel) - x;
            const shiftY = scaleY.invert(endYInPixel) - y;
            dispatch({ type: 'MOVE', payload: { shiftX, shiftY } });
        }
    }
    const handelBrushEnd = (0, react_1.useCallback)((brushData) => {
        //reset the brush start
        brushStartRef.current = null;
        if (brushData.mouseButton === 'main') {
            const trackID = (0, DimensionLayout_1.getLayoutID)(DIMENSION, brushData);
            if (trackID) {
                if (brushData.altKey) {
                    switch (selectedTool) {
                        default:
                            break;
                    }
                }
                else if (brushData.shiftKey) {
                    switch (selectedTool) {
                        case ToolTypes_1.options.zonePicking.id:
                            dispatch({ type: 'ADD_2D_ZONE', payload: brushData });
                            break;
                        default:
                            break;
                    }
                }
                else {
                    switch (selectedTool) {
                        default:
                            if (selectedTool != null) {
                                return dispatch({
                                    type: 'BRUSH_END',
                                    payload: {
                                        ...brushData,
                                        trackID: (0, DimensionLayout_1.getLayoutID)(DIMENSION, brushData),
                                    },
                                });
                            }
                    }
                }
            }
        }
    }, [selectedTool, dispatch, DIMENSION]);
    const handelOnDoubleClick = (0, react_1.useCallback)((e) => {
        const { x: startX, y: startY } = e;
        const trackID = (0, DimensionLayout_1.getLayoutID)(DIMENSION, { startX, startY });
        if (trackID) {
            dispatch({ type: 'FULL_ZOOM_OUT', payload: { trackID } });
        }
    }, [DIMENSION, dispatch]);
    const handleZoom = (event) => {
        const { x: startX, y: startY } = event;
        const trackID = (0, DimensionLayout_1.getLayoutID)(DIMENSION, { startX, startY });
        if (trackID) {
            if (trackID === 'CENTER_2D') {
                dispatch({ type: 'SET_2D_LEVEL', payload: event });
            }
            else {
                dispatch({ type: 'SET_ZOOM', payload: { event, trackID } });
            }
        }
    };
    const mouseClick = (0, react_1.useCallback)((position) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { x, y } = position;
        switch (selectedTool) {
            default:
                break;
        }
    }, [selectedTool]);
    return ((0, jsx_runtime_1.jsx)(react_d3_utils_1.ResponsiveChart, { children: ({ width, height }) => ((0, jsx_runtime_1.jsxs)(ViewerResponsiveWrapper, { width: width, height: height, children: [(0, jsx_runtime_1.jsx)(Spinner_1.default, { isLoading: isLoading, emptyText: emptyText }), data && data.length > 0 && ((0, jsx_runtime_1.jsx)(BrushTracker_1.BrushTracker, { onBrush: handelBrush, onBrushEnd: handelBrushEnd, onDoubleClick: handelOnDoubleClick, onClick: mouseClick, onZoom: handleZoom, style: {
                        width: '100%',
                        height: '100%',
                        margin: 'auto',
                        position: 'relative',
                        overflow: 'hidden',
                    }, children: (0, jsx_runtime_1.jsxs)(MouseTracker_1.MouseTracker, { style: { width: '100%', height: `100%`, position: 'absolute' }, children: [selectedTool && selectedTool === ToolTypes_1.options.slicing.id && ((0, jsx_runtime_1.jsx)(SlicingView_1.default, {})), (0, jsx_runtime_1.jsx)(CrossLinePointer_1.default, {}), (0, jsx_runtime_1.jsx)(XYLabelPointer_1.default, { data1D: spectrumData, layout: DIMENSION }), (0, jsx_runtime_1.jsx)(BrushXY_1.default, { brushType: BrushXY_1.BRUSH_TYPE.XY, dimensionBorder: DIMENSION.CENTER_2D }), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [spectrumData[0] && ((0, jsx_runtime_1.jsx)(BrushXY_1.default, { brushType: BrushXY_1.BRUSH_TYPE.X, dimensionBorder: DIMENSION.TOP_1D, height: margin.top })), spectrumData[1] && ((0, jsx_runtime_1.jsx)(BrushXY_1.default, { brushType: BrushXY_1.BRUSH_TYPE.Y, dimensionBorder: DIMENSION.LEFT_1D, width: margin.left }))] }), (0, jsx_runtime_1.jsx)(FooterBanner_1.default, { data1D: spectrumData, layout: DIMENSION }), (0, jsx_runtime_1.jsx)(Chart2D_1.default, { spectra: spectrumData })] }) }))] })) }));
}
function ViewerResponsiveWrapper(props) {
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const { width, height, children } = props;
    (0, react_1.useEffect)(() => {
        dispatch({ type: 'SET_DIMENSIONS', payload: { width, height } });
    }, [width, height, dispatch]);
    return children;
}
exports.ViewerResponsiveWrapper = ViewerResponsiveWrapper;
exports.default = Viewer2D;
